import { Component } from '@angular/core';
import { NavController, NavParams, AlertController, ToastController, LoadingController, ModalController } from 'ionic-angular';
import { Camera, CameraOptions } from '@ionic-native/camera';
import { DatePicker } from '@ionic-native/date-picker';

import { Invoice, Dokumen, Schedule } from '@providers/index';

import { DetailImagePage } from '../';

import { Utility } from '@providers/resources/utility';

@Component({
  selector: 'page-form-note',
  templateUrl: 'page.html'
})
export class FormInvPage {

  form:any ={
    desc          : '',
    dokument_id   : '',
    generated_name: '',
    inv_type      : '',
    value         : '',
    value2        : '',
    ket           : '',
    ket2          : '',
    date          : '',
    date2         : ''
  };

  project     : any = {};
  listCategory: any=[];
  loading     : any;
  img_url  = '';
  buildApk = this.utility.buildApk;
  
  constructor(
    public  navCtrl    : NavController,
    public  navParams  : NavParams,
    private toastCtrl  : ToastController,
    public  loadingCtrl: LoadingController,
    public  modalCtrl  : ModalController,
    public  datePicker : DatePicker,
    public  camera     : Camera,
    public  invApi     : Invoice,
    public  dokumenApi : Dokumen,
    public  scheduleApi: Schedule,
    public  utility    : Utility
  ) {
    this.project = this.navParams.get('project');
    this.img_url = this.dokumenApi.file_url;

    if(this.navParams.get('rec')!=undefined){
      this.form = this.navParams.get('rec');
      console.log('rec => ', this.form)
    }

    this.getCategory();
  }

  showLoading(){
    this.loading = this.loadingCtrl.create({
      content: 'Please wait...'
    });
    this.loading.present();
  }

  presentToast(msg){
    this.toastCtrl.create({
      message: msg,
      duration: 3000,
      position: 'top'
    }).present();
  }

  getCategory(){
    let params = {};
    this.invApi.category(params).subscribe((resp:any) => {
      this.listCategory = resp.data;
    });
    console.log('note category => ', this.listCategory);
  }
 
  save(){    
    this.showLoading();


    let params:any = {
    };
    params = this.form;

    params.project_id = this.project.id;

    console.log("params send => ", params);

    this.invApi.post(params).subscribe((resp:any) => {
      this.presentToast(resp.msg);
      this.loading.dismiss();
      this.form.desc = '';
      this.navCtrl.pop();
    },(err) => {
      this.presentToast('Error');
      this.loading.dismiss();
    });
  }


  selectDate(){
    this.datePicker.show({
      date: new Date(),
      mode: 'date',
      // minDate: new Date().valueOf(),
      androidTheme: this.datePicker.ANDROID_THEMES.THEME_DEVICE_DEFAULT_LIGHT
    }).then(
      date => this.form.date = new Date(date.getTime() - 
      date.getTimezoneOffset()*60000).toISOString(),
      err  => console.log('ERROR : '+ err)
    );
  }
  selectDate2(){
    this.datePicker.show({
      date: new Date(),
      mode: 'date',
      // minDate: new Date().valueOf(),
      androidTheme: this.datePicker.ANDROID_THEMES.THEME_DEVICE_DEFAULT_LIGHT
    }).then(
      date => this.form.date2 = new Date(date.getTime() - 
      date.getTimezoneOffset()*60000).toISOString(),
      err  => console.log('ERROR : '+ err)
    );
  }

  takePicture(camera=1){
    const options: CameraOptions = {
      quality: 25,
      destinationType: this.camera.DestinationType.DATA_URL,
      targetWidth : 1024,
      sourceType:camera
    }
    
    this.camera.getPicture(options).then((imageData) => {
     // imageData is either a base64 encoded string or a file URI
     // If it's base64 (DATA_URL):
     let base64Image = 'data:image/jpeg;base64,' + imageData;
     this.save_image(base64Image);
    }, (err) => {
     // Handle error
    });
  }


  save_image(img){
    let loading = this.loadingCtrl.create({
      content: 'Please wait...'
    });
    loading.present();

    let params = {img: img};
    this.dokumenApi.post(params).subscribe((resp:any) => {
      this.form.dokument_id=resp.data.id;
      this.form.generated_name=resp.data.generated_name;
      loading.dismiss();
    }, (err) => {
      loading.dismiss();
    });
  }

  viewImage(generated_name) {
    let profileModal = this.modalCtrl.create(DetailImagePage, { 
      url_image : this.img_url+this.form.generated_name
    });
    profileModal.present();
  }

}



// WEBPACK FOOTER //
// ./src/pages/project_mobile/form_inv/page.ts